import React from 'react';
import styled from 'styled-components';
import { useSelector } from 'react-redux';
import { TermsOfService } from '@assets/documents/TermsOfService';
import { Header } from '@app/navigation/header';
import { Navbar } from '@pages/splash/Navbar';
import { getIsAuthed } from '@utils/selectors';
import { Body, Container, Page, H1 } from '@ui';

const PageWrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
`;

const Content = () => {
  return <TermsOfService />;
};

const TermsOfServicePage = () => {
  const isAuthed = useSelector(getIsAuthed);
  return (
    <PageWrapper>
      {isAuthed ? <Header noActions /> : <Navbar />}
      <Body withFooter>
        <Page>
          <Container>
            <H1>Terms of Service</H1>
            <Content />
          </Container>
        </Page>
      </Body>
    </PageWrapper>
  );
};

export default TermsOfServicePage;
